import React from 'react';
// import ProCard from './ProCard'; // Assuming ProCard is in the same directory
import { Card } from 'antd'; // Optional, for loading spinner and layout
import { Link } from 'react-router-dom';

const ProCard = ({ prod = {} }) => {
  const { Description = 'No Name', Images = 'default-image.jpg', ShowcasePrice } = prod;
  return (
    <div>
      <div className="daimondsCard">
        <Link to={`/product/${prod.SKU}`}>
          <Card
            className='daimondsCard'
            hoverable
            style={{ margin: '10px', background: 'transparent' }}
            data-json={JSON.stringify(prod)}
            cover={
              <div className='prd-images'>
                <img alt={Description.substring(0, 20)} src={Images[0].FullUrl} />
                {Images[1]?.FullUrl && <img className='hvr-img' alt={Description.substring(0, 20)} src={Images[1].FullUrl} />}
              </div>
            }
          >
            <Card.Meta title={Description.length > 30 ? Description.substring(0, 25) + '...' : Description} description={`$${ShowcasePrice?.Value.toFixed(2)}`} />
          </Card>
        </Link>
      </div>
      {/* )} */}
    </div>
  );
};

export default ProCard;